import React from "react"
import { Box, Typography, Grid } from "src/UILibrary"
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined"
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined"
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined"
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined"
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined"
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined"
import { MEMBER_TYPE } from "src/modules/const"
import { useMediaQuery } from "react-responsive"
import { useLoginContext } from "src/hooks/useLoginContext"
interface Props {
  title: string
  icon: string
  active?: boolean
  onClick?: any
  subcount?: number
}

export const MyPageMenuItem = ({ title, icon, active, onClick, subcount }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const { userType } = useLoginContext()

  return (
    <>
      {isTablet ? (
        <Box
          display="flex"
          sx={{
            width: "250px",
            height: "72px",
            px: "20px",
            py: "28px",
            bgcolor: active ? "#FAFAFA" : "#F1F1F1",
            ":hover": { bgcolor: "#FAFAFA", cursor: "pointer" },
          }}
          onClick={onClick}
        >
          {icon == "inbox" ? <FileDownloadOutlinedIcon /> : <></>}
          {icon == "favorite_video" ? <VideocamOutlinedIcon /> : <></>}
          {icon == "job_information" ? <MessageOutlinedIcon /> : <></>}
          {icon == "register_information" ? <PersonOutlineOutlinedIcon /> : <></>}
          {icon == "reservation_manage" ? <DriveFileRenameOutlineOutlinedIcon /> : <></>}
          {icon == "event_manage" ? <PlayArrowOutlinedIcon /> : <></>}
          {icon == "notification_manage" ? <CampaignOutlinedIcon /> : <></>}
          {icon == "user_manage" ? <BookmarkBorderOutlinedIcon /> : <></>}
          {icon == "contact" ? <EmailOutlinedIcon /> : <></>}
          {icon == "book_library_manage" ? <LibraryBooksOutlinedIcon /> : <></>}

          <Typography.SubTitle
            className="notosans weight700"
            color="textPrimary"
            fontSize={14}
            sx={{ ml: "20px" }}
          >
            {title}
          </Typography.SubTitle>
        </Box>
      ) : (
        <Grid
          item
          lg={12 / (subcount ? subcount : 7)}
          md={12 / (subcount ? subcount : 7)}
          sm={12 / (subcount ? subcount : 7)}
          xs={12 / (subcount ? subcount : 7)}
          sx={{
            textAlign: "center",
            p: "0px",
            m: "0px",
            bgcolor: active ? "#FAFAFA" : "#F1F1F1",
            ":hover": { bgcolor: "#FAFAFA", cursor: "pointer" },
          }}
          onClick={onClick}
        >
          <Box sx={{ mt: "10px" }}>
            {icon == "inbox" ? <FileDownloadOutlinedIcon /> : <></>}
            {icon == "favorite_video" ? <VideocamOutlinedIcon /> : <></>}
            {icon == "job_information" ? <MessageOutlinedIcon /> : <></>}
            {icon == "register_information" ? <PersonOutlineOutlinedIcon /> : <></>}
            {icon == "reservation_manage" ? <DriveFileRenameOutlineOutlinedIcon /> : <></>}
            {icon == "event_manage" ? <PlayArrowOutlinedIcon /> : <></>}
            {icon == "notification_manage" ? <CampaignOutlinedIcon /> : <></>}
            {icon == "user_manage" ? <BookmarkBorderOutlinedIcon /> : <></>}
            {icon == "contact" ? <EmailOutlinedIcon /> : <></>}
            {icon == "book_library_manage" ? <LibraryBooksOutlinedIcon /> : <></>}
          </Box>

          {userType == MEMBER_TYPE.ADMINISTRATOR ? (
            <Typography.SubTitle
              className="notosans weight700 submenu-admin"
              color="textPrimary"
              fontSize={10}
              sx={{ mt: "-6px" }}
            >
              {title}
            </Typography.SubTitle>
          ) : (
            <Typography.SubTitle
              className="notosans weight700 submenu"
              color="textPrimary"
              fontSize={10}
              sx={{ mt: "-6px" }}
            >
              {title}
            </Typography.SubTitle>
          )}
        </Grid>
      )}
    </>
  )
}
